module.exports = __webpack_public_path__ + "img/zimg2.726a2887.png";